(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

$(document).ready(function () {
  if ($('.programme').length > 0) {
    if ($('.modal-compo-brochure').length > 0) {
      $('#annexe_submit').attr('href', $('#brochure-request').attr('href'));
      $('#brochure-request').on('click', function (e) {
        if ($('#serializedAnnexes').val() === '') {
          e.preventDefault();
          $('.modal-cache').removeClass('hidden');
          $('.modal-compo-brochure').removeClass('hidden');
          $('body').addClass("block-scroll");
        }
      });
      $('.annexe-item').on('click touch', function () {
        var serialized = $('.modal-compo-brochure form').serialize();
        var brochureRequestHref = $('#brochure-request').attr('href');
        $('#serializedAnnexes').val(serialized);
        $('#annexe_submit').attr('href', brochureRequestHref + (brochureRequestHref.includes('?') ? '&' : '?') + serialized);
      });
      $('.modal-close').on('click touch', function () {
        $('#serializedAnnexes').val('');
        $('.modal-cache').addClass('hidden');
        $('.modal-compo-brochure').addClass('hidden');
        $('body').removeClass("block-scroll");
      });
    }

    $('#annexe_submit').on('click', function (e) {
      var serialized = $('.modal-compo-brochure form').serialize();
      var brochureRequestHref = $('#brochure-request').attr('href');
      $('#serializedAnnexes').val(serialized);
      $('#annexe_submit').attr('href', brochureRequestHref + (brochureRequestHref.includes('?') ? '&' : '?') + serialized);
      $('.modal-cache').addClass('hidden');
      $('.modal-compo-brochure').addClass('hidden');
      $('body').removeClass("block-scroll");
    });
  } else if ($('.brochures').length > 0) {
    var isAnnexed = function isAnnexed(selectedProgramId) {
      return typeof annexedPrograms != "undefined" && annexedPrograms.includes(selectedProgramId);
    };

    var selectedProgramId = null;
    var selectedProgramName = null;
    $('#BrochureStep1Type_program .element-choice').on('click', function (e) {
      e.preventDefault();
      selectedProgramId = $(this).find('input').val();
      selectedProgramName = $(this).find('label').text();

      if (!isAnnexed(selectedProgramId)) {
        selectedProgramId = null;
        selectedProgramName = null;
      } else {
        $('.annexe-item.first p[data-popin-program-id="' + selectedProgramId + '"]').text($('.annexe-item.first p[data-popin-program-id="' + selectedProgramId + '"]').text().replace('%program%', selectedProgramName));
      }
    });

    if ($('.modal-compo-brochure').length > 0) {
      $('#BrochureStep1Type_submit').on('click touch', function (e) {
        if (selectedProgramId !== null) {
          e.preventDefault();
          $('.annexe-item[data-popin-program-id="' + selectedProgramId + '"]').removeClass('visually-hidden');
          $('.annexe-item.first p[data-popin-program-id="' + selectedProgramId + '"]').removeClass('visually-hidden');
          $('.modal-cache').removeClass('hidden');
          $('.modal-compo-brochure').removeClass('hidden');
          $('body').addClass("block-scroll");
        }
      });
      $('.modal-close').on('click touch', function () {
        $('#BrochureStep1Type_serializedAnnexes').val('');
        $('.modal-cache').addClass('hidden');
        $('.modal-compo-brochure').addClass('hidden');
        $('body').removeClass("block-scroll");
        $('.annexe-item[data-popin-program-id="' + selectedProgramId + '"]').addClass('visually-hidden');
        $('.annexe-item.first p[data-popin-program-id="' + selectedProgramId + '"]').addClass('visually-hidden');
      });
    }

    $('#annexe_submit').on('click', function (e) {
      e.preventDefault();
      var serialized = $('.modal-compo-brochure form').serialize();
      $('#BrochureStep1Type_serializedAnnexes').val(serialized);
      $('.modal-cache').addClass('hidden');
      $('.modal-compo-brochure').addClass('hidden');
      $('body').removeClass("block-scroll");
      $('.form-loader').addClass('active');
      $('form[name="BrochureStep1Type"]').submit();
    });
  }

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    var isEscape = false;

    if ("key" in evt) {
      isEscape = evt.key === "Escape" || evt.key === "Esc";
    } else {
      isEscape = evt.keyCode === 27;
    }

    if (isEscape) {
      $(".modal-close").click();
    }
  };
});

},{}]},{},[1]);
